import { FunctionsFetchError, FunctionsRelayError } from '@supabase/supabase-js';
import { supabase } from './supabase';

async function accountErrorMessage(error: unknown): Promise<string> {
  if (error instanceof FunctionsFetchError) {
    return 'The account service could not be reached. Check your connection. If this continues, ask your administrator to check the account service and portal configuration.';
  }
  if (error instanceof FunctionsRelayError) {
    return 'The account service is temporarily unavailable. Reload the account list to check whether the change completed before trying again.';
  }

  const response = (error as { context?: unknown } | null)?.context;
  if (response instanceof Response) {
    if (response.status === 404) {
      return 'Account management is not set up yet. Ask your administrator to deploy the account service before creating or updating logins.';
    }
    if (response.status === 401) {
      return 'Your sign-in could not be verified. Sign out and sign in again before saving.';
    }
    if (response.status >= 500) {
      return 'The account service encountered a problem. Reload the account list to check whether the change completed before trying again.';
    }
    try {
      const details = await response.clone().json();
      if (typeof details.error === 'string' && details.error.trim()) return details.error;
    } catch {
      // Gateway errors may not contain the account service's JSON response.
    }
    if (response.status === 403) {
      return 'The account service refused this request. Check your account permissions and portal configuration.';
    }
  }
  return 'The account update could not be confirmed. Reload the account list to check whether it completed before trying again.';
}

export async function manageLogin(body: Record<string, unknown>) {
  const { data, error } = await supabase.functions.invoke('user-admin', { body });
  if (error) throw new Error(await accountErrorMessage(error));
  if (data?.error) throw new Error(data.error);
  return data;
}
